import { compose, branch, renderNothing } from 'recompose';

import SubCategoryList from './SubCategoryList';

const enhance = compose(branch(({ subCategories }) => !subCategories, renderNothing));

export default enhance(SubCategoryList);
